import { forwardRef } from 'react'
import { Typography as MuiTypography, type TypographyProps as MuiTypographyProps } from '@mui/material'

export type TypographyProps = MuiTypographyProps

export const Typography = forwardRef<HTMLElement, TypographyProps>(function Typography(props, ref) {
  return <MuiTypography ref={ref} {...props} />
})
